export function isHomePath(path) {
  return /^\/home\/?$/i.test(path || '')
}

export function filterHomeRoutes(routes, allowed) {
  return routes.reduce((result, route) => {
    if (!allowed && (isHomePath(route.path || route.resCode) || route.path === '/home1')) return result
    const filtered = { ...route }
    if (route.children) {
      filtered.children = filterHomeRoutes(route.children, allowed)
      if (route.children.length && !filtered.children.length) return result
    }
    result.push(filtered)
    return result
  }, [])
}

// Only a visible leaf backed by an actual registered page is a landing page.
export function firstAccessiblePath(routes, resolve, parent = '') {
  for (const route of routes) {
    if (route.hidden || !route.path || /^(?:https?:)?\/\//i.test(route.path)) continue
    const path = route.path.startsWith('/') ? route.path : `${parent}/${route.path}`
    if (isHomePath(path) || path === '/home1') continue
    if (route.children && route.children.length) {
      const child = firstAccessiblePath(route.children, resolve, path)
      if (child) return child
    } else if (!/^https?:/i.test(path)) {
      const resolved = resolve(path).route
      if (resolved && resolved.matched.length && resolved.path !== '/404' &&
          !resolved.matched.some(record => record.meta && record.meta.requiresHome)) return path
    }
  }
  return null
}

export function landingPath(routes, allowed, resolve) {
  return allowed ? '/home' : firstAccessiblePath(routes, resolve) || '/no-access'
}
